/**
 * A receipt's pieces, drawn the same on Money's card (Board 8) and the
 * phone's sheet (Board 16 D): its photo, its chip, how it was paid — and the
 * three things the office does to one.
 */
import type { ReceiptCard } from '@rowted/shared'
import { StatusChip } from '../components/primitives.js'
import { RECEIPTS } from './copy.js'
import { VisitGlyph } from './glyphs.js'

/** Approve (with **Pay <name> back** as switched), reject with why, undo an approval (§12). */
export interface ReceiptActions {
  approve: (card: ReceiptCard, reimburse: boolean) => Promise<void>
  reject: (card: ReceiptCard, reason: string) => Promise<void>
  undo: (card: ReceiptCard) => Promise<void>
}

/** *Own money* · *Company card ··2208* · *Account*. */
export function paidWithWords(card: ReceiptCard): string {
  if (card.paidWith === 'company_card') return card.cardLast4 ? RECEIPTS.card(card.cardLast4) : RECEIPTS.paid.company_card
  return RECEIPTS.paid[card.paidWith]
}

/** The receipt's photo — the crew's own picture of it (Board 8: 112 × 150; Board 16 D: 96 × 128). */
export function ReceiptPhoto({ card, width, height }: { card: ReceiptCard; width: number; height: number }) {
  return (
    <span
      className="relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[10px] bg-surface-alt text-text-faint"
      style={{ width, height }}
    >
      {card.photo
        ? <img src={card.photo.url} alt={card.photo.name} className="h-full w-full object-cover" />
        : <VisitGlyph name="receipt" size={22} stroke={1.8} />}
    </span>
  )
}

export function ReceiptChip({ card }: { card: ReceiptCard }) {
  return <StatusChip group="receipt" status={card.state} className="shrink-0 whitespace-nowrap">{RECEIPTS.state[card.state]}</StatusChip>
}

